const DefaultImage = "/images/logos/default.png";

const Logo = "/images/logos/Logo.svg";
const LogSm = "/images/logos/Logo.svg";

const SidebarLogo = "/images/logos/sidebar-logo.svg";
const SidebarLogoIcon = "/images/logos/sidebar-logo-sm.svg";

const FallBackImg = "/images/misc/no-image.png";
const BlurImage = "/images/misc/blur.webp";

const Banner1 = "/images/banners/banner-1.jpg";
const Banner2 = "/images/banners/banner-2.jpg";
const Banner3 = "/images/banners/banner-3.jpg";
const Banner4 = "/images/banners/banner-4.jpg";
const Banner5 = "/images/banners/banner-5.jpg";
const Banner6 = "/images/banners/banner-6.jpg";

export const Logos = { Logo, LogSm, SidebarLogo, SidebarLogoIcon };
export { FallBackImg, BlurImage, DefaultImage, Logo, LogSm, SidebarLogo, SidebarLogoIcon };

export const Banners = { Banner1, Banner2, Banner3, Banner4, Banner5, Banner6 };
